export enum IconButtonColor {
  BLUE = '--blue',
  RED = '--red',
  BLACK = '--black',
  GREEN = '--green',
  GRAY = '--gray',
  WHITE = '--white',
}
